module.exports = "<div>\r\n    <p>\r\n      Seçilen paylaşımı sansürlemek istediğinize emin misiniz?\r\n    </p>\r\n    <button mat-raised-button color=\"warn\" style=\"float: right\" (click)=\"censorPost()\">Sansür Uygula</button>\r\n    <button mat-raised-button color=\"primary\" style=\"float: right;margin-right:7px;\" (click)=\"close()\">Vazgeç</button>\r\n  </div>\r\n "


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/addtoblackphoto/dialog/dialog.component.html
// module id = ../../../../../src/app/main/content/addtoblackphoto/dialog/dialog.component.html
// module chunks = main